import { alabamaCountiesList } from '../counties/alabama'
import { alaskaCountiesList } from '../counties/alaska'
import { arizonaCountiesList } from '../counties/arizona'
import { arkansasCountiesList } from '../counties/arkansas'
import { californiaCountiesList } from '../counties/california'
import { coloradoCountiesList } from '../counties/colorado'
import { connecticutCountiesList } from '../counties/connecticut'
import { delawareCountiesList } from '../counties/delaware'
import { floridaCountiesList } from '../counties/florida'
import { georgiaCountiesList } from '../counties/georgia'
import { hawaiiCountiesList } from '../counties/hawaii'
import { idahoCountiesList } from '../counties/idaho'
import { illinoisCountiesList } from '../counties/illinois'
import { indianaCountiesList } from '../counties/indiana'
import { iowaCountiesList } from '../counties/iowa'
import { kansasCountiesList } from '../counties/kansas'
import { kentuckyCountiesList } from '../counties/kentucky'
import { louisianaCountiesList } from '../counties/louisiana'
import { maineCountiesList } from '../counties/maine'
import { marylandCountiesList } from '../counties/maryland'
import { massachussettsCountiesList } from '../counties/massachussetts'
import { michiganCountiesList } from '../counties/michigan'
import { minnesotaCountiesList } from '../counties/minnesota'
import { mississippiCountiesList } from '../counties/mississippi'
import { missouriCountiesList } from '../counties/missouri'
import { montanaCountiesList } from '../counties/montana'
import { nebraskaCountiesList } from '../counties/nebraska'
import { nevadaCountiesList } from '../counties/nevada'
import { newhampshireCountiesList } from '../counties/newhampshire'
import { newjerseyCountiesList } from '../counties/newjersey'
import { newmexicoCountiesList } from '../counties/newmexico'
import { newyorkCountiesList } from '../counties/newyork'
import { northcarolinaCountiesList } from '../counties/northcarolina'
import { northdakotaCountiesList } from '../counties/northdakota'
import { ohioCountiesList } from '../counties/ohio'
import { oklahomaCountiesList } from '../counties/oklahoma'
import { oregonCountiesList } from '../counties/oregon'
import { pennsylvaniaCountiesList } from '../counties/pennsylvania'
import { rhodeislandCountiesList } from '../counties/rhodeisland'
import { southcarolinaCountiesList } from '../counties/southcarolina'
import { southdakotaCountiesList } from '../counties/southdakota'
import { tennesseeCountiesList } from '../counties/tennessee'
import { texasCountiesList } from '../counties/texas'
import { utahCountiesList } from '../counties/utah'
import { vermontCountiesList } from '../counties/vermont'
import { virginiaCountiesList } from '../counties/virginia'
import { washingtonCountiesList } from '../counties/washington'
import { westvirginiaCountiesList } from '../counties/westvirginia'
import { wisconsinCountiesList } from '../counties/wisconsin'
import { wyomingCountiesList } from '../counties/wyoming'

import moment from 'moment'
const fb = require('../firebaseConfig.js')
import firebase from 'firebase/app';
import axios from 'axios'

export const stripeAPIToken='pk_test_51HGaq6GBZf0U9jAiUjhCfOGITsKiFCzqSCsIIxxDi30G1SxXtQPvTc0eQbi8Ip2HCbwdf3w8NcnhmGhnYozbe9el00xEGnnUC0'
export const SERVERADDRESS = "https://orderupdates.kegseeker.com:5000/"
//export const SERVERADDRESS = "http://localhost:5000/"
export function copyObject(obj){
    var nobj = {};
    for (let key in obj) {
        if (typeof obj[key] === 'object'){
            nobj[key] = copyObject(obj[key]);
        } else {
            nobj[key] = obj[key];
        }
    }
    return nobj;
}


export function incrementbeerinventory(beerId, incrementquantity, theBeer)
    {
        //Find which field to increment, depending on container
        var fieldToIncrement = 'quantity'
        if(theBeer.multiSize ==1 ){
            if (theBeer.container =='barrel1') fieldToIncrement = 'barrel1Quantity'
            if (theBeer.container =='barrel2') fieldToIncrement = 'barrel2Quantity'
            if (theBeer.container =='can') fieldToIncrement = 'canQuantity'
            if (theBeer.container =='bottle') fieldToIncrement = 'bottleQuantity'

        }
        fb.beersCollection.where('id', '==', theBeer.id).get().then(docs => {
            docs.forEach(doc => {
                //var increment = parseInt(incrementquantity)
                var increment = firebase.firestore.FieldValue.increment(incrementquantity);
                fb.beersCollection.doc(doc.id).update({ [fieldToIncrement]: increment});

        })
        }).catch(err => {
        console.log(err)
        })
    }

export function cancelorderupdateinventory(suborderid, cancelledBy, cancelMessage)
    {
        var orderQuantity
        fb.ordersCollection.where('suborderid', '==', suborderid).get().then(docs => {
        docs.forEach(doc => {
            orderQuantity = parseInt(doc.data().orderQuantity)
            fb.ordersCollection.doc(doc.id).update({
                status: -1,
                cancelledOn: new Date(),
                //0=cancelled by brewery
                cancelledBy:cancelledBy,
                cancelMessage:cancelMessage,
            }).then((res2) => {
                console.log("Incrementing inventory")
                incrementbeerinventory(doc.data().beerId, orderQuantity)

            })

        })
    }).catch(err => {
        console.log(err)
    })

    }

    export function timeConverter(UNIX_timestamp){
        var a = new Date(UNIX_timestamp * 1000);
        var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        var weekdays = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
        var year = a.getFullYear();
        var month = months[a.getMonth()];
        var date = a.getDate();
        var weekDay = weekdays[a.getDay()];

        if (parseInt(date)==1||parseInt(date)==21||parseInt(date)==31) date = date+'st'
        else if (parseInt(date)==2||parseInt(date)==22) date = date+'nd'
        else if (parseInt(date)==3||parseInt(date)==23) date = date+'rd'
        else date = date+'th'

        var hour = a.getHours();
        var min = a.getMinutes();
        if(min<10) min = '0'+min
        var sec = a.getSeconds();
        var ampm
        if (hour>=12){
            hour = hour-12
            ampm='PM'
        }
        else ampm='AM'
        var time = weekDay + ', ' + date + ' ' + month + ' ' + year + ' ' + hour + ':' + min +' ' +ampm;
        return time;
      }
    export function timeConverterDateAndYear(UNIX_timestamp){
        var a = new Date(UNIX_timestamp * 1000);
        var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        var weekdays = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
        var year = a.getFullYear();
        var month = months[a.getMonth()];
        var date = a.getDate();
        var weekDay = weekdays[a.getDay()];

        if (parseInt(date)==1||parseInt(date)==21||parseInt(date)==31) date = date+'st'
        else if (parseInt(date)==2||parseInt(date)==22) date = date+'nd'
        else if (parseInt(date)==3||parseInt(date)==23) date = date+'rd'
        else date = date+'th'

        var hour = a.getHours();
        var min = a.getMinutes();
        if(min<10) min = '0'+min
        var sec = a.getSeconds();
        var ampm
        if (hour>=12){
            hour = hour-12
            ampm='PM'
        }
        else ampm='AM'
        var time = weekDay + ', ' + date + ' ' + month + ' ' + year
        return time;
    }

      export function timeConverterObject(UNIX_timestamp){
        var timeObject = []
        var a = new Date(UNIX_timestamp * 1000);
        var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        var weekdays = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
        var year = a.getFullYear();
        var month = months[a.getMonth()];
        var date = a.getDate();
        var weekDay = weekdays[a.getDay()];

        var hour = a.getHours();
        var min = a.getMinutes();
        if(min<10) min = '0'+min
        var sec = a.getSeconds();
        var ampm
        if (hour>12){
            hour = hour-12
            ampm='PM'
        }
        else ampm='AM'
        var time = weekDay + ', ' + date + ' ' + month + ' ' + year + ' ' + hour + ':' + min +' ' +ampm;
        timeObject.year=year
        timeObject.date = date
        timeObject.month = month
        timeObject.day = weekDay
        timeObject.time = hour + ':' + min +' ' +ampm
        return timeObject;

      }


      export function timeConverterDateOnly(UNIX_timestamp){
        var a = new Date(UNIX_timestamp * 1000);
        var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        var weekdays = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
        var year = a.getFullYear();
        var month = months[a.getMonth()];
        var date = a.getDate();
        var weekDay = weekdays[a.getDay()];

        if (parseInt(date)==1||parseInt(date)==21||parseInt(date)==31) date = date+'st'
        else if (parseInt(date)==2||parseInt(date)==12||parseInt(date)==22) date = date+'nd'
        else if (parseInt(date)==3||parseInt(date)==13||parseInt(date)==23) date = date+'rd'
        else date = date+'th'

        var hour = a.getHours();
        var min = a.getMinutes();
        if(min<10) min = '0'+min
        var sec = a.getSeconds();
        var ampm
        if (hour>=12){
            hour = hour-12
            ampm='PM'
        }
        else ampm='AM'
        var time = weekDay + ', ' + date + ' ' + month;
        return time;
      }

      export function htmldatetimetounix(htmldate, htmltime){
        var date = new Date();
        var timeString =htmltime.toString()
        var hours = timeString.slice(0, 2);
        var mins = timeString.slice(3, 5);
        var timeOffset = parseInt(hours)*60*60*1000 + parseInt(mins)*60*1000
        //Timezoneoffset returns minutes
        var zoneOffset = date.getTimezoneOffset()*60*1000
        var newTime = Date.parse(htmldate) + zoneOffset + timeOffset
        return newTime

      }
      export function htmldatetounix(htmldate){
        var date = new Date();
        //Timezoneoffset returns minutes
        var zoneOffset = date.getTimezoneOffset()*60*1000
        var newTime = Date.parse(htmldate) + zoneOffset
        return newTime

    }
    //To send a text email to an email address
    export function sendemailsendgrid(email, subject, text){
        
        //Check if user allows emails
        fb.usersCollection.where('email','==',email).get().then(docs => {
            docs.forEach(doc => {
                if (doc.data().sendOrderEmails){
                    
                    var bodyFormData = new FormData();
                    bodyFormData.set('subject', subject);
                    bodyFormData.set('text', text);
                    bodyFormData.set('email', email);
                    bodyFormData.set('apikey', 'jhdsh5v57689jh7y5g567hh88ike32690knhgt67tgg46yv');

                    axios({
                        method: 'post',
                        url: 'https://orderupdates.kegseeker.com:80/testroute',
                        data: bodyFormData,
                        headers: {'Content-Type': 'multipart/form-data' }
                        })
                        .then(function (response) {
                            //handle success
                            //console.log(response);
                        })
                        .catch(function (response) {
                            //handle error
                            console.log(response);
                        });

                }
            })

        })
        //End of check

    }
    //To send an html email to an email address
    export function sendemailhtml(emailto, emailfrom, subject, emailhtml, fromname){
        var url= 'https://orderupdates.kegseeker.com:5000/sendemailtoemail'
        //Check if user allows emails

        var bodyFormData = new FormData();
        bodyFormData.set('subject', subject);
        bodyFormData.set('emailhtml', emailhtml);
        bodyFormData.set('emailfrom', emailfrom);
        bodyFormData.set('emailto', emailto);
        bodyFormData.set('company', fromname);
        bodyFormData.set('apikey', 'jhdsh5v57689jh7y5g567hh88ike32690knhgt67tgg46yv');

        axios({
            method: 'post',
            url: url,
            data: bodyFormData,
            headers: {'Content-Type': 'multipart/form-data' }
            })
            .then(function (response) {
                //handle success
                //console.log(response);
            })
            .catch(function (response) {
                //handle error
                console.log(response);
            });

        //End of check

    }

    export function sendemailsendgriduid(uid, subject, text){
        //Check if user allows emails
        var docRef = fb.usersCollection.doc(uid);
        var mailApiKey = process.env.VUE_APP_email_apiKey
        var url= 'https://orderupdates.kegseeker.com:5000/testroute'

        docRef.get().then(function(doc) {
            if (doc.exists) {
                if (doc.data().sendOrderEmails){
                    var email = doc.data().email
                    var email1 = doc.data().email1
                    var email2 = doc.data().email2
                    var email3 = doc.data().email3
                    var bodyFormData = new FormData();
                    bodyFormData.set('subject', subject);
                    bodyFormData.set('text', text);
                    bodyFormData.set('email', email);
                    if(email1) bodyFormData.set('email1', email1)
                    if(email2) bodyFormData.set('email1', email2)
                    if(email3) bodyFormData.set('email1', email3)
                    bodyFormData.set('apikey', mailApiKey);
    
                    axios({
                        method: 'post',
                        url: url,
                        data: bodyFormData,
                        headers: {'Content-Type': 'multipart/form-data' }
                        })
                        .then(function (response) {
                            //handle success
                            //console.log(response);
                        })
                        .catch(function (response) {
                            //handle error
                            console.log(response);
                        });
    
                }
            } else {
                // doc.data() will be undefined in this case
                console.log("Could not find user with uid" + uid);
            }
        }).catch(function(error) {
            console.log("Error getting document:", error);
        });

    }

    export function sendToEmailAddress(emailto, emailfrom, emailhtml, subject, company){
        var url= 'https://orderupdates.kegseeker.com:5000/sendemailtoemail'
        var mailApiKey = process.env.VUE_APP_email_apiKey
        var bodyFormData = new FormData();
        bodyFormData.set('subject', subject);
        bodyFormData.set('emailto', emailto);
        bodyFormData.set('emailfrom', emailfrom);
        bodyFormData.set('company', company);
        bodyFormData.set('emailhtml', emailhtml);
        bodyFormData.set('apikey', mailApiKey);
        axios({
            method: 'post',
            url: url,
            data: bodyFormData,
            headers: {'Content-Type': 'multipart/form-data' }
            })
            .then(function (response) {
                //handle success
                //console.log(response);
            })
            .catch(function (response) {
                //handle error
                console.log(response);
            });

    }
    
    export function sendChatEmail(uid, subject, text, fromname, kegseekermail){
        //Check if user allows emails
        var docRef = fb.usersCollection.doc(uid);
        var mailApiKey = process.env.VUE_APP_email_apiKey

        docRef.get().then(function(doc) {
            if (doc.exists) {
                if (doc.data().sendOrderEmails){
                    var email = doc.data().email
                    var email1 = doc.data().email1
                    var email2 = doc.data().email2
                    var email3 = doc.data().email3
                    var bodyFormData = new FormData();
                    bodyFormData.set('subject', subject);
                    bodyFormData.set('text', text);
                    bodyFormData.set('email', email);
                    bodyFormData.set('kegseekeremail', kegseekermail);
                    bodyFormData.set('fromname', fromname);
                    if(email1) bodyFormData.set('email1', email1)
                    if(email2) bodyFormData.set('email1', email2)
                    if(email3) bodyFormData.set('email1', email3)
                    bodyFormData.set('apikey', mailApiKey);
    
                    axios({
                        method: 'post',
                        url: 'https://orderupdates.kegseeker.com:5000/messagesemail',
                        data: bodyFormData,
                        headers: {'Content-Type': 'multipart/form-data' }
                        })
                        .then(function (response) {
                            //handle success
                            //console.log(response);
                        })
                        .catch(function (response) {
                            //handle error
                            console.log(response);
                        });
    
                }
            } else {
                // doc.data() will be undefined in this case
                console.log("Emails not allowed");
            }
        }).catch(function(error) {
            console.log("Error getting document:", error);
        });

    }


    export function sendemailinfo(emailfrom, company, message){
        var mailApiKey = process.env.VUE_APP_email_apiKey
        var bodyFormData = new FormData();
        bodyFormData.set('subject', "General inquiry from " + company);
        bodyFormData.set('text', message);
        bodyFormData.set('emailfrom', emailfrom);
        bodyFormData.set('apikey', mailApiKey);
        axios({
            method: 'post',
            url: 'https://orderupdates.kegseeker.com:5000/infoemail',
            data: bodyFormData,
            headers: {'Content-Type': 'multipart/form-data' }
            })
            .then(function (response) {
                //handle success
                //console.log(response);
            })
            .catch(function (response) {
                //handle error
                console.log(response);
            });
    }

    export function sendemailsupport(emailfrom, company, message, subject){
        var mailApiKey = process.env.VUE_APP_email_apiKey
        var bodyFormData = new FormData();
        bodyFormData.set('subject', subject);
        bodyFormData.set('text', message);
        bodyFormData.set('emailfrom', emailfrom);
        bodyFormData.set('company', company);
        bodyFormData.set('apikey', mailApiKey);
        axios({
            method: 'post',
            url: 'https://orderupdates.kegseeker.com:5000/supportemail',
            data: bodyFormData,
            headers: {'Content-Type': 'multipart/form-data' }
            })
            .then(function (response) {
                //handle success
                //console.log(response);
            })
            .catch(function (response) {
                //handle error
                console.log(response);
            });
    }

    export function sendnotification(uid, message){
        var mailApiKey = process.env.VUE_APP_email_apiKey
        var bodyFormData = new FormData();
        bodyFormData.set('uid', uid);
        bodyFormData.set('message', message);
        bodyFormData.set('apikey', mailApiKey);
        axios({
            method: 'post',
            url: 'https://orderupdates.kegseeker.com:5000/sendnotification',
            data: bodyFormData,
            headers: {'Content-Type': 'multipart/form-data' }
            })
            .then(function (response) {
                //handle success
                //console.log(response);
            })
            .catch(function (response) {
                //handle error
                console.log(response);
            });
    }


    export function sendemail(email, subject, text){
        var apiKey = process.env.VUE_APP_mailgun_api_key
        var session_url = 'https://api.mailgun.net/v3/karmic.mailgun.org/messages'
              axios({
                method: 'post',
                url: session_url,
                auth: {
                    username: 'api',
                    password: apiKey
                },
                params: {
                    from: 'Keg Country <info@kegcountry.com>',
                    to:  email,
                    subject: subject,
                    text: text
                }
            }).then(
                response => {
                    console.log(response)
                },
                reject => {
                    console.log(reject)
                }
            )
    }

    export function checkAddress(street1, street2, city, zip, state){
        var apiKey = process.env.VUE_APP_address_api_key
        street1 = street1.replace('.', '');
        street1 = street1.replace('#', '');
        street1 = street1.replace(',', '');
        street2 = street2.replace('.', '');
        street2 = street2.replace('#', '');
        street2 = street2.replace(',', '');


        var theURL = "https://api.address-validator.net/api/verify?StreetAddress=" +street1 + ' ' + 
        street2 + '&City='+city+'&PostalCode=' +zip+'&CountryCode=us' + '&APIKey=' + apiKey

        console.log("URL + ")
        console.log(theURL)

        return axios({
            method: 'get',
            url: theURL,
          }).then(response => {
             return response
          })
          .catch(function (response) {
            //handle error
            console.log(response);
            return "ERROR"
        });
        
    }

    export function getLocation(){

        var strr = [];

            axios({
                method: 'get',
                url: "https://api.ipify.org?format=json"

            }).then(
                response => {
                    var ipaddress = response.data.ip
                    console.log(ipaddress)

                    var locationURL = "https://ipapi.co/" + ipaddress +"/json"
                    //Get location
                    axios({
                        method: 'get',
                        url: locationURL
        
                    }).then(
                        response => {
                            var address = response.data
                            console.log("Returning ")
                            console.log(address)
                            return address
                            
                            
                        },
                        reject => {
                            console.log(reject)
                        }
                    )
                    //End of location
                },
                reject => {
                    console.log(reject)
                }
            )

    }

    export function fullBeerStylesList(){

        var beerCat1 = "Pale Ales"
        var beerNames1 = []
        beerNames1.push("American Amber Ale")
        beerNames1.push("American Pale Ale")
        beerNames1.push("Blonde Ale")
        beerNames1.push("English-Style Bitter")
        beerNames1.push("English-Style Pale Ale (ESB)")
        var beer1 = {group: beerCat1, beers: beerNames1}

        var beerCat2 = "Strong Ales"
        var beerNames2 = []
        beerNames2.push("American Barley Wine")
        beerNames2.push("American Imperial Red Ale")
        beerNames2.push("British-Style Barley Wine Ale")
        beerNames2.push("English-Style Old Ale")
        var beer2 = {group: beerCat2, beers: beerNames2}

        var beerCat3 = "Scottish-Style Ales"
        var beerNames3 = []
        beerNames3.push("Scotch Ale/Wee Heavy")
        beerNames3.push("Scottish-Style Ale")
        var beer3 = {group: beerCat3, beers: beerNames3}


        var beerCat4 = "Dark Lagers"
        var beerNames4 = []
        beerNames4.push("American Amber Lager")
        beerNames4.push("German-Style Dunkel")
        beerNames4.push("German-Style Marzen / Oktoberfest",)
        beerNames4.push("German-Style Schwarzbier",)
        beerNames4.push("Vienna-Style Lager")
        var beer4 = {group: beerCat4, beers: beerNames4}

        var beerCat5 = "Belgian Styles"
        var beerNames5 = []
        beerNames5.push("Belgian-Style Blonde Ale")
        beerNames5.push("Belgian-Style Dubbel")
        beerNames5.push("Belgian-Style Golden Strong Ale")
        beerNames5.push("Belgian-Style Pale Ale")
        beerNames5.push("Belgian-Style Quadrupel")
        beerNames5.push("Belgian-Style Saison")
        beerNames5.push("Belgian-Style Tripel")
        var beer5 = {group: beerCat5, beers: beerNames5}


        var beerCat6 = "Wild/Sour Beers"
        var beerNames6 = []
        beerNames6.push("American Brett")
        beerNames6.push("American Sour")
        beerNames6.push("Belgian-Style Flanders")
        beerNames6.push("Belgian-Style Fruit Lambic")
        beerNames6.push("Belgian-Style Lambic/Gueuze")
        beerNames6.push("Contemporary Gose")
        var beer6 = {group: beerCat6, beers: beerNames6}



        var beerCat7 = "Brown Ales"
        var beerNames7 = []
        beerNames7.push("American Brown Ale")
        beerNames7.push("English-Style Brown Ale")
        beerNames7.push("English-Style Mild")
        var beer7 = {group: beerCat7, beers: beerNames7}

        var beerCat8 = "Hybrid Beers"
        var beerNames8=[]
        beerNames8.push("American Cream Ale")
        beerNames8.push("French-Style Biere de Garde")
        beerNames8.push("California Common")
        beerNames8.push("German-Style Altbier")
        beerNames8.push("German-Style Kolsch")
        beerNames8.push("Irish-Style Red Beer")
        var beer8 = {group: beerCat8, beers: beerNames8}

        var beerCat9 = "Pilseners and Pale Lagers"
        var beerNames9 = []
        beerNames9.push("American Lager")
        beerNames9.push("Bohemian-Style Pilsener")
        beerNames9.push("European-Style Export")
        beerNames9.push("German-Style Helles")
        beerNames9.push("German-Style Pilsner")
        var beer9 = {group: beerCat9, beers: beerNames9}

        var beerCat10 = "India Pale Ales"
        var beerNames10 = []
        beerNames10.push("American IPA")
        beerNames10.push("English-Style IPA")
        beerNames10.push("Imperial India Pale Ale")
        beerNames10.push("New England IPA")
        var beer10 = {group: beerCat10, beers: beerNames10}

        var beerCat11 = "Specialty Beers"
        var beerNames11  = []
        beerNames11.push("American Black Ale")
        beerNames11.push("Barrel-Aged Beer")
        beerNames11.push("Chocolate Beer")
        beerNames11.push("Fruit and Field Beer")
        beerNames11.push("Gluten-Free Craft Beer")
        beerNames11.push("Herb and Spice Beer")
        beerNames11.push("Honey Beer")
        beerNames11.push("Pumpkin Beer")
        beerNames11.push("Rye Beer")
        beerNames11.push("Session Beer")
        beerNames11.push("Smoke Beer")
        beerNames11.push("Specialty Beer")
        var beer11 = {group: beerCat11, beers: beerNames11}

        var beerCat12 = "Wheat Beers"
        var beerNames12 = []
        beerNames12.push("American-Style Wheat Wine Ale")
        beerNames12.push("American Wheat")
        beerNames12.push("Belgian-Style Witbier")
        beerNames12.push("Berliner-Style Weisse")
        beerNames12.push("German-Style Hefeweizen")
        beerNames12.push("German-Style Dunkelweizen")
        var beer12 = {group: beerCat12, beers: beerNames12}
        

        var beerCat13 = "Porters"
        var beerNames13 = []
        beerNames13.push("American Imperial Porter")
        beerNames13.push("Baltic-Style Porter")
        beerNames13.push("English-Style Brown Porter")
        beerNames13.push("Robust Porter")
        beerNames13.push("Smoke Porter")
        var beer13 = {group: beerCat13, beers: beerNames13}

        var beerCat14 = "Stouts"
        var beerNames14 = []
        beerNames14.push("American Imperial Stout")
        beerNames14.push("American Stout")
        beerNames14.push("English-Style Oatmeal Stout")
        beerNames14.push("English-Style Sweet Stout (Milk Stout)")
        beerNames14.push("Irish-Style Dry Stout")
        beerNames14.push("")
        var beer14 = {group: beerCat14, beers: beerNames14}

        var beerCat15 = "Bocks"
        var beerNames15 = []
        beerNames15.push("German-Style Bock")
        beerNames15.push("German-Style Doppelbock")
        beerNames15.push("German-Style Maibock")
        beerNames15.push("German-Style Weizenbock")
        var beer15 = {group: beerCat15, beers: beerNames15}

        var fullList = [beer1, beer2, beer3, beer4, beer5, beer6, beer7, beer8, beer9, beer10, beer11, beer12, beer13, beer14, beer15]
        
        return fullList

    }

    export const deliveryAgents = [
                    'Self',
                    'Brown Bag',
                    'CBG',
                    'Crest',
                    'Scout',
                    'Southern',
                    'Stone',
                    'Wine Warehouse',
                ]

    export const californiaCountiesListold = [
            'Alameda',
            'Alpine',
            'Amador',
            'Butte',
            'Calaveras',
            'Colusa',
            'Contra Costa',
            'Del Norte',
            'El Dorado',
            'Fresno',
            'Glenn',
            'Humboldt',
            'Imperial',
            'Inyo',
            'Kern',
            'Kings',
            'Lake',
            'Lassen',
            'Los Angeles',
            'Madera',
            'Marin',
            'Mariposa',
            'Mendocino',
            'Merced',
            'Modoc',
            'Mono',
            'Monterey',
            'Napa',
            'Nevada',
            'Orange',
            'Placer',
            'Plumas',
            'Riverside',
            'Sacramento',
            'San Benito',
            'San Bernardino',
            'San Diego',
            'San Francisco',
            'San Joaquin',
            'San Luis Obispo',
            'San Mateo',
            'Santa Barbara',
            'Santa Clara',
            'Santa Cruz',
            'Shasta',
            'Sierra',
            'Siskiyou',
            'Solano',
            'Sonoma',
            'Stanislaus',
            'Sutter',
            'Tehama',
            'Trinity',
            'Tulare',
            'Tuolumne',
            'Ventura',
            'Yolo',
            'Yuba',
            ]

      export const usStates = [
        { name: 'ALABAMA', abbreviation: 'AL'},
        { name: 'ALASKA', abbreviation: 'AK'},
        { name: 'ARIZONA', abbreviation: 'AZ'},
        { name: 'ARKANSAS', abbreviation: 'AR'},
        { name: 'CALIFORNIA', abbreviation: 'CA'},
        { name: 'COLORADO', abbreviation: 'CO'},
        { name: 'CONNECTICUT', abbreviation: 'CT'},
        { name: 'DELAWARE', abbreviation: 'DE'},
        { name: 'DISTRICT OF COLUMBIA', abbreviation: 'DC'},
        { name: 'FLORIDA', abbreviation: 'FL'},
        { name: 'GEORGIA', abbreviation: 'GA'},
        { name: 'HAWAII', abbreviation: 'HI'},
        { name: 'IDAHO', abbreviation: 'ID'},
        { name: 'ILLINOIS', abbreviation: 'IL'},
        { name: 'INDIANA', abbreviation: 'IN'},
        { name: 'IOWA', abbreviation: 'IA'},
        { name: 'KANSAS', abbreviation: 'KS'},
        { name: 'KENTUCKY', abbreviation: 'KY'},
        { name: 'LOUISIANA', abbreviation: 'LA'},
        { name: 'MAINE', abbreviation: 'ME'},
        { name: 'MARYLAND', abbreviation: 'MD'},
        { name: 'MASSACHUSETTS', abbreviation: 'MA'},
        { name: 'MICHIGAN', abbreviation: 'MI'},
        { name: 'MINNESOTA', abbreviation: 'MN'},
        { name: 'MISSISSIPPI', abbreviation: 'MS'},
        { name: 'MISSOURI', abbreviation: 'MO'},
        { name: 'MONTANA', abbreviation: 'MT'},
        { name: 'NEBRASKA', abbreviation: 'NE'},
        { name: 'NEVADA', abbreviation: 'NV'},
        { name: 'NEW HAMPSHIRE', abbreviation: 'NH'},
        { name: 'NEW JERSEY', abbreviation: 'NJ'},
        { name: 'NEW MEXICO', abbreviation: 'NM'},
        { name: 'NEW YORK', abbreviation: 'NY'},
        { name: 'NORTH CAROLINA', abbreviation: 'NC'},
        { name: 'NORTH DAKOTA', abbreviation: 'ND'},
        { name: 'OHIO', abbreviation: 'OH'},
        { name: 'OKLAHOMA', abbreviation: 'OK'},
        { name: 'OREGON', abbreviation: 'OR'},
        { name: 'PENNSYLVANIA', abbreviation: 'PA'},
        { name: 'RHODE ISLAND', abbreviation: 'RI'},
        { name: 'SOUTH CAROLINA', abbreviation: 'SC'},
        { name: 'SOUTH DAKOTA', abbreviation: 'SD'},
        { name: 'TENNESSEE', abbreviation: 'TN'},
        { name: 'TEXAS', abbreviation: 'TX'},
        { name: 'UTAH', abbreviation: 'UT'},
        { name: 'VERMONT', abbreviation: 'VT'},
        { name: 'VIRGINIA', abbreviation: 'VA'},
        { name: 'WASHINGTON', abbreviation: 'WA'},
        { name: 'WEST VIRGINIA', abbreviation: 'WV'},
        { name: 'WISCONSIN', abbreviation: 'WI'},
        { name: 'WYOMING', abbreviation: 'WY' }
    ];
    
    export const mainBeerStylesList = [

        'Amber Ale',
        'Belgian',
        'Blonde',
        'Brown Ale',
        'Golden Ale',
        'Hefeweizen',
        'IPA',
        'Lager',
        'Pale Ale',
        'Pilsner',
        'Porter',
        'Red Ale',
        'Saison',
        'Stout',
        'Wheat',
        'Other',
        ]

    export const drinkCategories = [
        'Beers',
        'Wines',
        'Hard Kombucha',
        'Hard Cider',
        'Hard Seltzer',
        'Craft Cocktails',
        'Spirits',
        'Non Alcoholic',
        ]

    export const wineCategories = [
        'Beaujolais',
        'Cabernet Sauvignon',
        'Cava',
        'Chardonnay',
        'Chenin Blanc',
        'Chianti',
        'Grenache',
        'Lambrusco',
        'Madeira',
        'Malbec',
        'Marsala',
        'Mead',
        'Meritage',
        'Merlot',
        'Moscato',
        'Muscat',
        'Petite Sirah',
        'Pinot Blanc',
        'Pinot Grigio',
        'Pinot Noir',
        'Port',
        'Rose',
        'Sangiovese',
        'Sauvignon Blanc',
        'Sherry',
        'Viognier',
        'Zinfandel',
        'Other',
        ]